(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Service = App.loadClass('core::Angular/Service');

  exports.ValidationService = (function(superClass) {
    extend(ValidationService, superClass);

    function ValidationService(state, fields, zones_service, pgis, layers) {
      this.state = state;
      this.fields = fields;
      this.zones_service = zones_service;
      this.pgis = pgis;
      this.layers = layers;
      this.setBackButtonDisable = bind(this.setBackButtonDisable, this);
      this.setFieldData = bind(this.setFieldData, this);
      this.setupByMode = bind(this.setupByMode, this);
      this.setModeSettings = bind(this.setModeSettings, this);
      this.checkBoundary = bind(this.checkBoundary, this);
      this.wentBack = bind(this.wentBack, this);
      this.validate = bind(this.validate, this);
      this.cleanup = bind(this.cleanup, this);
      this.initializeStep = bind(this.initializeStep, this);
      this.setStepScope = bind(this.setStepScope, this);
      this.setMainScope = bind(this.setMainScope, this);
      this.setProcessMode = bind(this.setProcessMode, this);
      this.setFieldsData = bind(this.setFieldsData, this);
      this.setHideNext = bind(this.setHideNext, this);
      this.setHideBack = bind(this.setHideBack, this);
      this.setDisabled = bind(this.setDisabled, this);
      this.setText = bind(this.setText, this);
      this.setZones = bind(this.setZones, this);
      this.disabled = {
        next: false,
        required: false,
        back: false
      };
      this.text = {
        next: 'Next',
        back: 'Back',
        required: 'Required *'
      };
      this.validGeometryTypes = ['Polygon', 'MultiPolygon'];
      this.process_mode = 'zone-add';
      this.wait_before_next_step = false;
      this.setFieldsData();
    }

    ValidationService.prototype.setZones = function(zones1) {
      this.zones = zones1;
      return void 0;
    };

    ValidationService.prototype.setText = function(key, text) {
      this.text[key] = text;
      return this.mainscope.text = this.text;
    };

    ValidationService.prototype.setDisabled = function(key, text) {
      this.disabled[key] = text;
      return this.mainscope.disabled = this.disabled;
    };

    ValidationService.prototype.setHideBack = function(bool) {
      return this.mainscope.hide_back = bool;
    };

    ValidationService.prototype.setHideNext = function(bool) {
      return this.mainscope.hide_next = bool;
    };

    ValidationService.prototype.setFieldsData = function() {
      return this.fields.all().then((function(_this) {
        return function(result) {
          return _this.fields_data = result.data.data;
        };
      })(this));
    };

    ValidationService.prototype.setProcessMode = function() {
      return this.process_mode = this.fields.getProcessMode();
    };

    ValidationService.prototype.setMainScope = function(mainscope) {
      var ref;
      this.mainscope = mainscope;
      this.checkBoundary();
      if (((ref = this.mainscope) != null ? ref.field_data : void 0) != null) {
        return this.setFieldData(this.mainscope.field_data);
      }
    };

    ValidationService.prototype.setStepScope = function(stepscope, initialize) {
      var ref;
      if (initialize == null) {
        initialize = true;
      }
      if ((ref = this.stepscope) != null) {
        if (typeof ref.cleanup === "function") {
          ref.cleanup();
        }
      }
      this.stepscope = stepscope;
      if (initialize) {
        return this.initializeStep();
      }
    };

    ValidationService.prototype.initializeStep = function() {
      return this.validate();
    };

    ValidationService.prototype.cleanup = function() {
      var ref, ref1, ref2, ref3, ref4;
      this.settings = null;
      this.process_mode = 'zone-add';
      this.setMainScope(null);
      this.setStepScope(null);
      this.fields_data = null;
      this.setFieldsData();
      if ((ref = this.mainscope) != null) {
        if (typeof ref.$destroy === "function") {
          ref.$destroy();
        }
      }
      if ((ref1 = this.stepscope) != null) {
        if (typeof ref1.$destroy === "function") {
          ref1.$destroy();
        }
      }
      if ((ref2 = this.fields) != null) {
        if (typeof ref2.cleanup === "function") {
          ref2.cleanup();
        }
      }
      if ((ref3 = this.zones_service) != null) {
        if (typeof ref3.cleanup === "function") {
          ref3.cleanup();
        }
      }
      return (ref4 = this.pgis) != null ? typeof ref4.cleanup === "function" ? ref4.cleanup() : void 0 : void 0;
    };

    ValidationService.prototype.validate = function(param) {
      var ref, ref1;
      if (this.stepscope != null) {
        if (this.stepscope.validate(param) === true) {
          return (ref = this.mainscope) != null ? ref.disabled.next = false : void 0;
        } else {
          return (ref1 = this.mainscope) != null ? ref1.disabled.next = true : void 0;
        }
      }
    };

    ValidationService.prototype.wentBack = function() {
      var i, len, ref, results, z, zones;
      zones = this.getFieldData().zones;
      if ((zones != null ? zones.zones : void 0) != null) {
        ref = zones.zones;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          z = ref[i];
          results.push(z.visible.clearLayers());
        }
        return results;
      }
    };

    ValidationService.prototype.checkBoundary = function() {
      return void 0;
    };

    ValidationService.prototype.setModeSettings = function(settings) {
      this.settings = settings;
      return void 0;
    };

    ValidationService.prototype.setupByMode = function() {
      var ref;
      if ((ref = this.settings.process_mode) === 'zone-add' || ref === 'irrigation-add') {
        this.fields.setFieldsId(this.settings.fid);
        this.fields.setYear(this.settings.year);
      }
      if (this.settings.process_mode === 'zone-edit') {
        this.fields.setFieldsId(this.settings.fid);
        this.fields.setYear(this.settings.year);
        this.fields.setLayersId(this.settings.layers_id);
        this.fields.setLayerTitle(this.settings.layers_title);
      }
      return this.fields.setProcessMode(this.settings.process_mode);
    };

    ValidationService.prototype.setFieldData = function(field_data1) {
      this.field_data = field_data1;
      return void 0;
    };

    ValidationService.prototype.getFieldData = function() {
      return this.field_data;
    };

    ValidationService.prototype.setBackButtonDisable = function(field_data, mode) {
      if (field_data.process_mode === mode) {
        return this.mainscope.disabled.back = true;
      } else {
        return this.mainscope.disabled.back = false;
      }
    };

    ValidationService.prototype.clearLayers = function() {
      var ref, ref1;
      this.layers.destroyAllSubHandlers();
      App.layer_store["delete"]((ref = this.mainscope) != null ? (ref1 = ref.field_data) != null ? ref1.id : void 0 : void 0);
      this.pgis.removeAddedLayers();
      return this.pgis.clearBoundaryLayer();
    };

    ValidationService.prototype.canContinue = function() {
      if (this.field_data != null) {
        return true;
      } else {
        this.state.go('grower.fields');
        return false;
      }
    };

    ValidationService.prototype.convertGeometryCollection = function(collection) {
      var converted, geometry, i, len, ref, ref1;
      converted = [];
      ref = collection.geometry.geometries;
      for (i = 0, len = ref.length; i < len; i++) {
        geometry = ref[i];
        if (ref1 = geometry.type, indexOf.call(this.validGeometryTypes, ref1) >= 0) {
          converted.push({
            type: "Feature",
            properties: {},
            geometry: geometry
          });
        }
      }
      return converted;
    };

    return ValidationService;

  })(Service);

}).call(this);
